import Joi from "joi-browser";

const UpdateProduct = Joi.object().keys({
    materialImage: Joi.when(Joi.ref("$isBundle"), {
        is: false,
        then: Joi.string()
            .label("Material Image")
            .required()
            .error((errors) => ({
                template: " {{message}}",
                context: {
                    errors: errors.length,
                    message: "is Required",
                },
            })),
        otherwise: Joi.string().label("Material Image").allow("").allow(null),
    }),
    productName: Joi.string().required().trim().label("Product Name"),
    description: Joi.string().required().trim().label("Product Description"),
    industries: Joi.array().items(Joi.object().required()).label("Industries"),
    tags: Joi.array()
        .items(
            Joi.object().keys({
                id: Joi.number(),
                name: Joi.string(),
                isCreated: Joi.boolean(),
                isDeleted: Joi.boolean(),
            })
        )
        .label("Tags"),
    instructions: Joi.array()
        .items(Joi.string().required())
        .label("Instructions"),
    universalModel: Joi.object().required().label("Product Scope"),
    supportedCountries: Joi.when(Joi.ref("$isUniversalModel"), {
        is: false,
        then: Joi.array().min(1).label("Supported Countries"),
        otherwise: Joi.optional(),
    }),
    coverImage: Joi.array().items(Joi.string().required()).label("Cover Image"),
    images: Joi.array().items(Joi.string()).label("Product Images"),
    version: Joi.string().trim().required().label("Version Name"),
    whatsNew: Joi.array().items(
        Joi.string().required().label("Version Description")
    ),
});

const ManageModelForm = Joi.object().keys({
    productName: Joi.string()
        .regex(/^[a-zA-Z0-9][a-zA-Z0-9 ]*$/)
        .required()
        .trim()
        .label("Product Name")
        .error((errors) => {
            let err = errors[0];
            if (err.type === "string.regex.base") {
                return {
                    template: " {{message}}",
                    context: {
                        errors: errors.length,
                        message: " Can only include alphabets and numbers",
                    },
                };
            } else if (err.type === "any.empty") {
                return {
                    template: " {{message}}",
                    context: {
                        errors: errors.length,
                        message: " Cannot be empty",
                    },
                };
            }
            return errors;
        }),
    materialName: Joi.when(Joi.ref("$isBundle"), {
        is: false,
        then: Joi.string().required().label("Material Name"),
        otherwise: Joi.string().allow("").label("Material Name"),
    }),
    materialImage: Joi.when(Joi.ref("$isBundle"), {
        is: false,
        then: Joi.string()
            .label("Material Image")
            .required()
            .error((errors) => ({
                template: " {{message}}",
                context: {
                    errors: errors.length,
                    message: "is Required",
                },
            })),
        otherwise: Joi.string().label("Material Image").allow(""),
    }),
    description: Joi.string().required().trim().label("Product Description"),
    compatibleWith: Joi.array()
        .items(Joi.object().required())
        .label("Compatible With"),
    supportedAccessories: Joi.array()
        .items(Joi.object().keys({ value: Joi.number(), label: Joi.string() }))
        .label("Supported Accessories"),
    industries: Joi.array().items(Joi.object().required()).label("Industries"),
    tags: Joi.array()
        .items(
            Joi.object().keys({
                id: Joi.number(),
                name: Joi.string(),
                isCreated: Joi.boolean(),
                isDeleted: Joi.boolean(),
            })
        )
        .label("Tags"),
    productVersion: Joi.string().trim().required().label("Version Name"),
    whatsNew: Joi.array().items(
        Joi.string().required().label("Version Description")
    ),
    universalModel: Joi.object().required().label("Product Scope"),
    supportedCountries: Joi.when(Joi.ref("$isUniversalModel"), {
        is: false,
        then: Joi.array().min(1).label("Supported Countries"),
        otherwise: Joi.optional(),
    }),
    coverImage: Joi.array().items(Joi.string().required()).label("Cover Image"),
    images: Joi.array().items(Joi.string().required()).label("Product Images"),
    instructions: Joi.array()
        .items(Joi.string().required())
        .label("Instructions"),
});

const ManageSubsciptionsForm = Joi.object({
    solo: Joi.when(Joi.ref("$showModelType"), {
        is: true,
        then: Joi.object().required().label("Product Type"),
    }),

    choosenSubscriptionTypes: Joi.when("$minimumPlansSet", {
        is: false,
        then: Joi.bool()
            .label("Subscribtion plans")
            .error((errors) => ({
                template: " {{message}}",
                context: {
                    errors: errors.length,
                    message: "needs to have at least one plan selected",
                },
            })),
    }),
    monthlySubscriptionDollar: Joi.when(Joi.ref("$monthly"), {
        is: true,
        then: Joi.when(Joi.ref("$isPricePlanSkippable"), {
            is: false,
            then: Joi.when(Joi.ref("$monthly"), {
                is: true,
                then: Joi.number().positive().required().label("Dollar"),
                otherwise: Joi.number().positive().allow([null, ""]),
            }),
        }),
    }),
    monthlySubscriptionEuro: Joi.when(Joi.ref("$monthly"), {
        is: true,
        then: Joi.when(Joi.ref("$isPricePlanSkippable"), {
            is: false,
            then: Joi.when(Joi.ref("$monthly"), {
                is: true,
                then: Joi.number().positive().required().label("Euro"),
                otherwise: Joi.number().positive().allow([null, ""]),
            }),
        }),
    }),

    annualSubscriptionDollar: Joi.when(Joi.ref("$annual"), {
        is: true,
        then: Joi.when(Joi.ref("$isPricePlanSkippable"), {
            is: false,
            then: Joi.when(Joi.ref("$annual"), {
                is: true,
                then: Joi.number().positive().required().label("Dollar"),
                otherwise: Joi.number().positive().allow([null, ""]),
            }),
        }),
    }),
    annualSubscriptionEuro: Joi.when(Joi.ref("$annual"), {
        is: true,
        then: Joi.when(Joi.ref("$isPricePlanSkippable"), {
            is: false,
            then: Joi.when(Joi.ref("$annual"), {
                is: true,
                then: Joi.number().positive().required().label("Euro"),
                otherwise: Joi.number().positive().allow([null, ""]),
            }),
        }),
    }),
});

export default { ManageModelForm, ManageSubsciptionsForm, UpdateProduct };
